import { createSelector } from '@reduxjs/toolkit'

export const selectRecipient = (state) => state.recipient

export const selectUserProfile = createSelector(
  selectRecipient,
  (recipient) => recipient.userProfile
)

export const selectUserPreferences = createSelector(
  selectRecipient,
  (recipient) => recipient.userPreferences
)

export const selectUpdatingEmail = createSelector(
  selectRecipient,
  (recipient) => recipient.updatingEmail
)

export const selectUserShipments = (state) => state.recipient.shipments
export const selectShipmentsLoading = (state) => state.recipient.loading
export const selectShipmentsError = (state) => state.recipient.error
